// extracted by mini-css-extract-plugin
export var button = "_jw-0";
export var donut = "_jw-1";
export var donutFill = "_jw-3";
export var donutTrack = "_jw-2";